import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Menu,
  MenuItem,
  Fab,
  Grid,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import api from '../../api/api';

const PAGE_SIZE = 5;
const DepartmentListingPage = () => {

  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentDepartment, setCurrentDepartment] = useState(null);
  const [name, setName] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogType, setDialogType] = useState('add'); // 'add' or 'edit'

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const response = await api.get('/api/Departments');
      setDepartments(response.data);
    } catch (error) {
      console.error('Error fetching departments', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDialog = (type, department = null) => {

    setDialogType(type);
    setCurrentDepartment(department);
    if (department) {
      setName(department.name);
    } else {
      setName('');
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentDepartment(null);
    setName('');
  };

  const handleSaveDepartment = async () => {
    if (name.trim() === '') {
      return;
    }

    try {
      if (dialogType === 'add') {
        await api.post('/api/Departments', { name });
      } else {
        const id = currentDepartment.id;
        await api.put(`/api/Departments/${currentDepartment.id}`, { id, name });
      }
      fetchDepartments();
      handleCloseDialog();
    } catch (error) {
      console.error('Error saving department', error);
    }
  };

  const handleDeleteDepartment = async () => {
    try {
      await api.delete(`/api/Departments/${currentDepartment.id}`);
      fetchDepartments();
      handleCloseDialog();
    } catch (error) {
      console.error('Error deleting department', error);
    }
  };

  const handleMenuOpen = (event, department) => {
    setCurrentDepartment(department);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box  sx={{ p: 2 }}>
      <Typography marginBottom={2} component="p" variant="h5">Departments</Typography>
      {loading ? (
        <Typography>Loading...</Typography>
      ) : departments.length === 0 ? (
        <Typography>No Department Added.</Typography>
      ) : (
        <Grid container spacing={2}>
          {departments.map((department) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={department.id}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6">{department.name}</Typography>
                    </Box>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={(event) => handleMenuOpen(event, department)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => {
          handleOpenDialog('edit', currentDepartment);
          handleMenuClose();
        }}>Edit</MenuItem>
        <MenuItem onClick={() => {
          handleOpenDialog('delete', currentDepartment);
          handleMenuClose();
        }}>Delete</MenuItem>
      </Menu>
      <Fab color="primary" aria-label="add" sx={{ position: 'fixed', bottom: 16, right: 16 }} onClick={() => handleOpenDialog('add')}>
        <AddIcon />
      </Fab>
      {(dialogType === 'add' || dialogType === 'edit') && (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>{dialogType === 'add' ? 'Add New Department' : 'Edit Department'}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Department Name"
              type="text"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleSaveDepartment} variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {dialogType === 'delete' && (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this department?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleDeleteDepartment} variant="contained" color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default DepartmentListingPage;
